import { Outlet } from 'react-router-dom'
import { ReactNode } from 'react'

export type UseCallDataExtractionLayoutReturn = {
  children: ReactNode
}

export function useCallDataExtractionLayout(): UseCallDataExtractionLayoutReturn {
  return { children: <Outlet /> }
}
